module.exports = __webpack_public_path__ + "img/3.49110149.jpg";